import { render, staticRenderFns } from "./answerPanel.vue?vue&type=template&id=22796390&scoped=true"
import script from "./answerPanel.vue?vue&type=script&lang=js"
export * from "./answerPanel.vue?vue&type=script&lang=js"
import style0 from "./answerPanel.vue?vue&type=style&index=0&id=22796390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22796390",
  null
  
)

export default component.exports